import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// Instant reads: API GET answers are kept in memory until the server announces
// a change (see src/services/apiCache.js). Installed before anything fetches.
import './services/apiCache';
import App from './App';
import reportWebVitals from './reportWebVitals';
import startAutoRefresh from './autoRefresh';

// Import our Tailwind CSS
import './index.css';

// Preview bootstrap: when the standalone control panel embeds this app for a
// live preview, it passes the owner's admin token in the URL hash
// (#cp_token=...). Store it so the (otherwise login-gated) page can render,
// then strip the hash. Internal tool only — hardened (postMessage) once the
// panel moves to its own subdomain.
(function previewBootstrap() {
  try {
    const params = new URLSearchParams(window.location.search);
    const hash = new URLSearchParams(window.location.hash.replace(/^#/, ''));
    const cpToken = hash.get('cp_token');
    if (params.get('preview') === 'draft' && cpToken) {
      localStorage.setItem('token', cpToken);
      if (!localStorage.getItem('user')) {
        localStorage.setItem('user', JSON.stringify({ role: 'admin', email: 'preview', preview: true }));
      }
      // remove the token from the address bar but keep ?preview=draft
      window.history.replaceState(null, '', window.location.pathname + window.location.search);
    }
  } catch (e) {
    /* no-op */
  }
})();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Keep installed-app (PWA) sessions as fresh as the site: new-build prompt +
// data reload after long background stays. See src/autoRefresh.js.
startAutoRefresh();

// Offline support: register the service worker so the app opens and shows its
// last data with no internet. Sale writes made offline are queued and synced
// by src/offline/* (started from within <App/>). Registered after load so it
// never competes with the first paint.
// In the desktop app the local engine already serves the app and keeps the
// data offline; a service worker would only get in the way of updates.
if ('serviceWorker' in navigator && !window.kipara) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch((err) => {
      // A failed SW registration must never break the app — it just means no
      // offline support on this device/session.
      console.warn('Service worker registration failed:', err);
    });
  });
}
